/** knb 定义的通用api */
var commonAPI = require('../api')

/** 自定义的业务API */
var businessAPI = [
    'closeWindow',
    'setRRButton',
    'setRLButton',
    'setLRButton',
    'setLLButton',
    'setCalendersEvent',
    'deleteCalendersEvent',
    'queryCalendersEvent',
    'menuTitle',
    'setSegments',
    // 'actionSheet',
    'datePicker',
    // 'vibrate',
    'toast',
    'uploadMedia',

    // 'pickContact',
    'getReplyLayout',
    'editPhoto',
    'cropImage',
    // 'getDeviceInfo',
    // 'capture',
    'copyToClipboard',
    'getWebViewCapture'
]

// 默认是没有重复的
module.exports = [].concat(commonAPI, businessAPI)


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/dpzeus/api.js
// module id = 516
// module chunks = 0